import { commonVerbs } from "lib/localization";
import React from "react";
import { defineMessages } from "react-intl";

export const titles = defineMessages({
  avoidIntersections: {
    id: "PlannerOnboardingModal.avoidIntersectionsTitle",
    defaultMessage: "Avoid Intersections",
  },
  controlPoints: {
    id: "PlannerOnboardingModal.controlPointsTitle",
    defaultMessage: "Control Points",
  },
  mapTypes: {
    id: "PlannerOnboardingModal.mapTypesTitle",
    defaultMessage: "Map Types",
  },
  customCues: {
    id: "PlannerOnboardingModal.customCuesTitle",
    defaultMessage: "Custom Cues",
  },
  drawLines: {
    id: "PlannerOnboardingModal.drawLinesTitle",
    defaultMessage: "Draw Lines",
  },
});

titles.followRoads = commonVerbs.followRoads;

export const descriptionsValues = {
  strong: (...chunks) => <strong>{chunks}</strong>,
};

export const descriptions = defineMessages({
  followRoads: {
    id: "PlannerOnboardingModal.followRoadsDescription",
    defaultMessage:
      "Use the <strong>Follow Roads</strong> tool to plan a trip by clicking along your intended path using <strong>Control Points</strong>",
  },
  avoidIntersections: {
    id: "PlannerOnboardingModal.avoidIntersectionsDescription",
    defaultMessage:
      "Avoid clicking in intersections. This can cause your <strong>cuesheet</strong> to have errors. Always click before or after the intersection along the road you wish to take.",
  },
  controlPoints: {
    id: "PlannerOnboardingModal.controlPointsDescription",
    defaultMessage:
      "<strong>Control Points</strong> can fence in your route, use these to maintain your route’s integrity while dragging and dropping to edit your route.",
  },
  mapTypes: {
    id: "PlannerOnboardingModal.mapTypesDescription",
    defaultMessage:
      "Switch maps to take advantage of different routing engines and different views. Get stuck when routing? Use this tool to get around roadblocks. ",
  },
  customCues: {
    id: "PlannerOnboardingModal.customCuesDescription",
    defaultMessage:
      "You can edit your cues and add <strong>Custom Cues</strong> to personalize your <strong>cuesheet</strong> and route.",
  },
  drawLines: {
    id: "PlannerOnboardingModal.drawLinesDescription",
    defaultMessage:
      "Stuck or can’t route on an unmarked trail? <strong>Draw Lines</strong> can get you around unroutable areas.",
  },
});

export const tips = [
  {
    key: "followRoads",
    gif: "/images/planner-onboarding/follow-roads.gif",
  },
  {
    key: "avoidIntersections",
    gif: "/images/planner-onboarding/clicked-intersection-warning.gif",
  },
  {
    key: "controlPoints",
    gif: "/images/planner-onboarding/control-points.gif",
  },
  {
    key: "mapTypes",
    gif: "/images/planner-onboarding/map-types.gif",
  },
  {
    key: "customCues",
    gif: "/images/planner-onboarding/custom-cue.gif",
  },
  {
    key: "drawLines",
    gif: "/images/planner-onboarding/draw-lines.gif",
  },
];
